$(document).ready(function(){
    $("input").keyup(function(){
      var companyname = $("#company_name").val();
      var gstnumber = $("#gstin_number").val();
       $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: { "attributes" : {"company_name" :companyname , "gstin_number" :gstnumber } },
                success: function(){   
                   console.log('attributes updated successfully');
                },
                dataType: "json"
          });
    });
      $(".buttons").click(function(){
      var companyname = $("#company_name").val();
      var gstnumber = $("#gstin_number").val();
       $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: { "attributes" : {"company_name" :companyname , "gstin_number" :gstnumber } },
                success: function(){   
                   console.log('attributes updated successfully');
                },
                dataType: "json"
          });
    });

  });